function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.342 3.981a1.04 1.04 0 011.47 0l2.207 2.206a1.04 1.04 0 010 1.471l-8.824 8.824a1.04 1.04 0 01-1.471 0l-2.206-2.206a1.04 1.04 0 010-1.47l8.824-8.825zM16.019.305a1.04 1.04 0 011.47 0l2.206 2.206a1.04 1.04 0 010 1.47l-1.47 1.471a1.04 1.04 0 01-1.471 0l-2.206-2.206a1.04 1.04 0 010-1.47l1.47-1.471zM1.375 15.055a.709.709 0 011.174-.277l2.673 2.673a.709.709 0 01-.277 1.174L.934 19.962a.709.709 0 01-.896-.896l1.337-4.01z",
  fill: "#B5BFCD"
});

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default SvgEdit;